import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Color } from "../../../GlobalStyles";
import ServiceCM from "../../../services/cartmoduleServices";
import CollegeData from "../../../services/httpCollege";
import Service from "../../../services/httpService";
import CCService from "../../../services/httpServiceWithoutSuperAdmin";
import BackendDownErrorHandling from "../../reusables/BackendDownErrorHandling/BackendDownErrorHandling";
import Loader from "../../reusables/Loader/Loader";
import SideNavigationBar from "../../reusables/SideNavigationBar/SideNavigationBar";
import OngoingEvents from "../OngoingEvents/OngoingEvents";
import "../OngoingEvents/OngoingEvents.css";
import OnGoingGroupSessions from "../OnGoingGroupSessions/OnGoingGroupSessions";
import UpcomingPrograms from "../UpcomingPrograms/UpcomingPrograms";
import BatchCard from "../BatchCard/BatchCard";
import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import { GraduationCap as Graduation } from "lucide-react";
import * as XLSX from "xlsx";

const CollegeInfoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const services = new CCService();
  const service = new Service();
  const cartService = new ServiceCM();
  const collegeService = new CollegeData();
  let college_data_name = location.state?.college_name || "";
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [college_id, setCollege_id] = useState(null);
  const [college_name, setCollege_name] = useState("");
  // console.log("college id", college_id);
  const { userDetails, accessRights } = useSelector((store) => store.rights);
  const [entireGroupSessionData, setEntireGroupSessionData] = useState([]);
  const [activityTypeData, setActivityTypeData] = useState([]);
  const [durationData, setDurationData] = useState([]);
  const [mentorData, setMentorData] = useState([]);
  const [collegeData, setCollegeData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [activity_name, setActivity_name] = useState();
  const [college_name1, setCollege_name1] = useState();
  const [duration_name, setDuration_name] = useState();
  const [mentor_name, setMentor_name] = useState();
  const [batch_name, setBatch_name] = useState();
  const [errorOccurred, setErrorOccurred] = useState(false);
  const [ceeBatch, setCeeBatch] = useState([]);
  const [all_ug, setAll_ug] = useState([]);

  const activityTypeGetter = async () => {
    try {
      const res = await cartService.get("/sku?type=Group");
      // console.log("Response from backend for activity name:", res.data);
      setActivityTypeData(res.data);
      return res.data;
    } catch (err) {
      console.log(err);

      if (err?.response.status === 501) {
        setErrorOccurred(true);
      }
    }

    // console.log("Response activity type data", activityTypeData);
  };

  const DurationGetter = async () => {
    try {
      const res = await service.get("/duration");
      // console.log("Response from backend for duration:", res.durations);

      // setDurationData(getTimeFormated(res.durations))
      return res.durations;
    } catch (err) {
      console.log(err);

      if (err?.response.status === 501) {
        setErrorOccurred(true);
      }
    }
    // console.log("Response duration type data", durationData);
  };

  const CollegeGetter = async () => {
    try {
      const res = await collegeService.get("/college");
      // console.log("Response from backend for college:", res.data);
      setCollegeData(res.data);
      return res.data;
    } catch (err) {
      console.log(err);

      if (err?.response.status === 501) {
        setErrorOccurred(true);
      }
    }
    // console.log(" Response college type data", collegeData);
  };

  const mentorGetter = async () => {
    try {
      const res = await collegeService.get(
        `${process.env.REACT_APP_API_URL}/mentorModule/mentor/user`
      );
      // console.log("Response from backend for mentor:", res.data);
      setMentorData(res.data);
      return res.data;
    } catch (err) {
      console.log(err);

      if (err?.response.status === 501) {
        setErrorOccurred(true);
      }
    }
    // console.log("Response mentor type data", mentorData);
  };

  const batchGetter = async () => {
    try {
      const res = await collegeService.get(
        `${process.env.REACT_APP_API_URL}/collegeModule/userGroup`
      );
      // console.log("Response from backend for batch:", res.data);
      setBatchData(res.data);
      return res.data;
    } catch (err) {
      console.log(err);

      if (err?.response.status === 501) {
        setErrorOccurred(true);
      }
    }
    // console.log("Response bacth type data", batchData);
  };

  const handleUserDetails = async () => {
    try {
      const preUser = await services.get("/user/userDetail");
      //batch data getter
      return preUser.userDetail;
    } catch (err) {
      console.log("Error: ", err);

      if (err?.response.status === 501) {
        setErrorOccurred(true);
      }
    }
  };

  const data_manupulator_activity = (activityType) => {
    // console.log("activity type", activityType);
    // let temp = activityType;
    let temp = activityType.filter((act) => act.type === "Group");
    temp = temp.map((bat) => {
      bat.key = bat.act_type_name;
      bat.id = bat.id;
      bat.type = bat.type;
      return bat;
    });
    // console.log("temp rows activity:", temp);
    setActivity_name(temp);
    // console.log("activity group names", activity_name);
  };
  const data_manupulator_duration = (duration) => {
    // console.log("duration name", duration);

    let temp = duration;
    temp = temp?.map((bat) => {
      bat.key = bat.duration_name;
      // bat.id = bat.id;
      return bat;
    });
    // console.log("temp rows batch:", temp);
    setDuration_name(temp);
  };
  const data_manupulator_mentor = (mentor) => {
    // console.log("mentor type", mentor);

    let temp = mentor;
    temp = temp?.map((bat) => {
      bat.key = bat.first_name;
      bat.id = bat.user_id;
      return bat;
    });
    // console.log("temp rows mentor:", temp);
    setMentor_name(temp);
  };
  const data_manupulator_college = (college) => {
    // console.log("college type", college);

    let temp = college;
    temp = temp?.map((bat) => {
      bat.key = bat.college_name;
      bat.id = bat.id;
      return bat;
    });
    setCollege_name1(temp);
    // console.log("temp rows batch:", temp);
  };

  const data_manupulator_batch = (batch) => {
    // console.log("bactyh type", batch);

    let temp = batch;
    temp = temp?.map((bat) => {
      bat.key = bat.user_group_name;
      bat.id = bat.id;
      return bat;
    });
    // console.log("temp rows batch:", temp);
    setBatch_name(temp);
  };

  // function to get all the group sessions of a user from backend and store it in state variable
  const batchDataGetter = async (user_id) => {
    try {
      const res = await service.get(`/groupSession?ca_user_id=${user_id}`);
      // console.log("group session info RESPONSE:", res.data);

      return res.data;
    } catch (err) {
      console.log(err);

      if (err?.response.status === 501) {
        setErrorOccurred(true);
      }
    }
  };

  const batchCeeGetter = (user_id) => {
    try {
      const data = services.get(`/collegeAdmin/batchCee?user_id=${user_id}`);
      return data;
    } catch (error) {
      console.log("error in batchCeeGetter", error);
    }
  };

  useEffect(() => {
    const handleEffect = async () => {
      const headers = {
        Authorization: `Bearer ${Cookies.get("token")}`,
      };
      if (Cookies.get("token") === null || Cookies.get("token") === undefined) {
        navigate("/");
      }
      // console.log("headers...", headers);
      try {
        const preUser = await services.get("/collegeAdmin/college", {
          headers,
        });

        console.log("pre user", preUser)

        if (preUser.collegDetail.length === 0) {
          Cookies.remove("token");
          navigate("/");
        } else {
          setCollege_id(preUser.collegDetail[0].college_id);
          setCollege_name(preUser.collegDetail[0].college_name);
        }

        const preUserDetails = await handleUserDetails();
        const batchData = await batchDataGetter(preUserDetails.user_id);
        console.log("batch data", batchData);

        let temp_data = batchData.filter(
          (filtering_info, i) =>
            filtering_info.college_id ===
            parseInt(preUser.collegDetail[0].college_id)
        );
        // console.log("temp filtered college data", temp_data);
        setEntireGroupSessionData([...temp_data]);

        const [cee_batch] = await Promise.all([
          // activityTypeGetter(),
          // DurationGetter(),
          // mentorGetter(),
          // CollegeGetter(),
          // batchGetter(),
          batchCeeGetter(preUserDetails.user_id)
        ])
        setCeeBatch(cee_batch?.data);
        setAll_ug(cee_batch?.all_ug);

        // const activityType = await activityTypeGetter();
        // const duration = await DurationGetter();
        // const mentor = await mentorGetter();
        // const college = await CollegeGetter();
        // const batch = await batchGetter();
        // const cee_batch = await batchCeeGetter(preUserDetails.user_id);

        // const batchAccordingToCollege = await batchAccordingToCollegeGetter()

        // data_manupulator_activity(activityType);
        // data_manupulator_duration(duration);
        // data_manupulator_mentor(mentor);
        // data_manupulator_college(college);
        // data_manupulator_batch(batch);
      } catch (err) {
        console.log(err);

        if (err) {
          setErrorOccurred(true);
        }
        if (
          err?.response?.status === 401 &&
          err?.response?.data.message === "unauthorized"
        ) {
          console.log(err);
          navigate("/");
        }
      }
    };
    setLoading(false);
    handleEffect();
  }, []);
  const handleDownloadExcel = async (ug_id) => {
    try {
      console.log("Downloading Excel for ug_id:", ug_id);
      const url = `/collegeAdmin/get-pTest-analysis?ug_id=${ug_id}`;
      const response = await services.get(url);
      let candidates = response.data;

      if (Array.isArray(candidates) && typeof candidates[0] === 'string') {
        candidates = JSON.parse(candidates[0]);
      }

      if (typeof candidates === 'string') {
        candidates = JSON.parse(candidates);
      }

      if (!Array.isArray(candidates)) {
        candidates = [candidates];
      }

      console.log("Final candidates:", candidates);

      const rows = candidates.map((row, index) => {
        return {
          "S.No": index + 1,
          "Roll No": row.roll_no,
          "First Name": row.first_name,
          "Last Name": row.last_name,
          "Email": row.email_id,
          "Logical Ability - Tests Taken": row["Logical Ability_Test_Taken"],
          "Logical Ability - Best Score": row["Logical Ability_Best_Score"],
          "Logical Ability - Average Score": row["Logical Ability_Average_Score"],
          "Verbal Ability - Tests Taken": row["Verbal Ability_Test_Taken"],
          "Verbal Ability - Best Score": row["Verbal Ability_Best_Score"],
          "Verbal Ability - Average Score": row["Verbal Ability_Average_Score"],
          "Quantitative Ability - Tests Taken": row["Quantitative Ability_Test_Taken"],
          "Quantitative Ability - Best Score": row["Quantitative Ability_Best_Score"],
          "Quantitative Ability - Average Score": row["Quantitative Ability_Average_Score"],
          "Role Preparedness - Role 1": row.RP_Role1 || "",
          "Role Preparedness - Role 1 Average": row.RP_Role1_Avg,
          "Role Preparedness - Role 2": row.RP_Role2 || "",
          "Role Preparedness - Role 2 Average": row.RP_Role2_Avg,
          "Role Preparedness - Role 3": row.RP_Role3 || "",
          "Role Preparedness - Role 3 Average": row.RP_Role3_Avg,
          "Role Preparedness - Tests Taken": row["Role Preparedness_Test_Taken"],
          "Situational Judgement - Tests Taken": row["Situational Judgement_Test_Taken"],
          "Situational Judgement - Average": row["Situational Judgement_Avg"],
          "Sector Awareness - Tests Taken": row["Sector Awareness_Test_Taken"],
          "Sector Awareness - Average": row["Sector Awareness_Avg"],
          "Total Tests Taken": row.no_of_tests_taken,
        };
      });

      // 🔹 Convert to XLSX
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Practice Test Analysis");

      // 🔹 Generate binary string
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      // 🔹 Trigger download
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      const urlBlob = URL.createObjectURL(blob);
      link.href = urlBlob;
      link.download = `practice_test_analysis_${ug_id}.xlsx`;
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(urlBlob);
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleDownloadRawExcel = async (ug_id) => {
    try {
      const url = `/collegeAdmin/get-pTest-raw-analysis?ug_id=${ug_id}`;
      const response = await services.get(url);
      let candidates = response.data;

      // Parse the response data (same parsing logic as before)
      if (Array.isArray(candidates) && typeof candidates[0] === 'string') {
        candidates = JSON.parse(candidates[0]);
      }

      if (typeof candidates === 'string') {
        candidates = JSON.parse(candidates);
      }

      if (!Array.isArray(candidates)) {
        candidates = [candidates];
      }

      console.log("Raw candidates:", candidates);

      // Map raw data to Excel rows
      const rows = candidates.map((row, index) => {
        return {
          "S.No": index + 1,
          "Roll No": row.roll_no,
          "First Name": row.first_name,
          "Last Name": row.last_name,
          "Email": row.email_id,
          "Test Type": row.test_type_name,
          "Test Number": row.test_number ?? "N/A",
          "Mapped Test Name": row.mapped_test_name,
          "Score": row.score ?? "N/A",
        };
      });

      // Convert to XLSX
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Raw Practice Test Data");

      // Generate binary string
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      // Trigger download
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      const urlBlob = URL.createObjectURL(blob);
      link.href = urlBlob;
      link.download = `practice_test_raw_analysis_${ug_id}.xlsx`;
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(urlBlob);
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <>
      {errorOccurred ? (
        <BackendDownErrorHandling />
      ) : (
        <div
          className="OngoingEventsCard"
          style={{ marginTop: "2rem", marginLeft: "10rem" }}
        >
          <SideNavigationBar
            college_id={college_id}
            college_name={college_name}
          />
          {loading ? (
            <Loader show={loading} />
          ) : (
            <>
              <div className="topHeadings" style={{ display: "flex" }}>
                <p
                  style={{ color: Color.neutralMidGrey, marginBottom: "1rem" }}
                  onClick={() => navigate("/CollegeInfoPage")}
                >
                  {college_name}
                </p>
              </div>
              {college_id && college_name && (
                <>
                  {ceeBatch.length > 0 && <div style={{ marginBlock: "2rem" }}>
                    <p style={{ fontSize: "24px", marginBottom: "1rem" }}>CareerCarve Employability Examination Report</p>
                    <div className="flex items-center gap-2">

                      {ceeBatch.map((item) => (
                        <BatchCard
                          batch={{
                            ug_id: item.ug_id,
                            ug_name: item.user_group_name,
                          }}
                        />
                      ))}
                    </div>
                  </div>}

                  {/* <Typography
                    style={{ marginBottom: "2rem" }}
                    sx={{ fontSize: 20 }}
                  >
             
                  </Typography> */}

                  <p style={{ fontSize: "24px", marginBottom: "1rem" }}>       Ongoing Events</p>
                  <Typography class="topHeadings">
                    {college_data_name}
                  </Typography>
                  <OngoingEvents
                    college_id={college_id}
                    college_name={college_name}
                  />


                  {all_ug.length > 0 && <div style={{ marginBlock: "2rem" }}>
                    <p style={{ fontSize: "24px", marginBottom: "1rem" }}>Practice Test Analysis</p>
                    <div className="flex items-center gap-2">
                      {console.log("all ug", all_ug)}
                      {all_ug.map((item) => (
                        console.log("item ug id", item),
                        <Card
                          onClick={() => handleDownloadExcel(item?.ug_id)}
                          sx={{
                            cursor: 'pointer',
                            borderRadius: 2,
                            boxShadow: 1,
                            width: "370px",
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            overflow: 'visible',
                          }}
                        >
                          <CardContent sx={{ p: 3 }}>
                            <Box display="flex" alignItems="center" mb={2}>
                              <Box
                                sx={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: '50%',
                                  backgroundColor: '#E0F7FA',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mr: 1.5,
                                }}
                              >
                                <Graduation size={24} color="#007C91" />
                              </Box>
                              <Box>
                                <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "18px" }}>
                                  {item.user_group_name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: "14px" }}>
                                  Practice Test Analysis Report
                                </Typography>
                              </Box>
                            </Box>
                            <Button
                              variant="contained"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadExcel(item?.ug_id)
                              }}
                              sx={{
                                textTransform: 'none',
                                fontWeight: 500,
                                width: "100%",
                                background: "#1c8ea8",
                                fontSize: "16px",
                                boxShadow: 2,
                                '&:hover': { boxShadow: 4, background: "rgba(28, 142, 168, 0.9)", },
                              }}
                            >
                              Download Summary
                            </Button>
                            <Button
                              variant="contained"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadRawExcel(item?.ug_id)
                              }}
                              sx={{
                                marginTop: "1rem",
                                textTransform: 'none',
                                fontWeight: 500,
                                width: "100%",
                                background: "#1c8ea8",
                                fontSize: "16px",
                                boxShadow: 2,
                                '&:hover': { boxShadow: 4, background: "rgba(28, 142, 168, 0.9)", },
                              }}
                            >
                              Download Raw Data
                            </Button>
                          </CardContent>
                        </Card>
                      ))}
                    </div>
                  </div>}



                  <UpcomingPrograms
                    college_id={college_id}
                    college_name={college_name}
                  />
                  <OnGoingGroupSessions
                    activityTypeData={activityTypeData}
                    durationData={durationData}
                    mentorData={mentorData}
                    collegeData={collegeData}
                    batchData={batchData}
                    entireGroupSessionData={entireGroupSessionData}
                    path={window.location.pathname}
                  />
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default CollegeInfoPage;
